<template>
    <div class="houseDeposit">
      <bv-top></bv-top>
      <van-card v-for="(item, index) in agreeList" :key="index">
        <div slot="title" >
          <div class="titleContent"  style="padding:10px 10px 10px 10px" >交存编号：{{item.busiNo}}</div>
          <div style="float:right;text-align: left" >
            <!--          <div class="titleContent" style="float:right" >未交</div>-->
            <van-button type="primary" size="small" align="float:right" style="text-align: right" v-if="item.billState === '0'" plain>待签署</van-button>
            <van-button type="primary" size="small" align="float:right" style="text-align: right" v-if="item.billState === '1'" plain>正在签署</van-button>
            <van-button type="primary" size="small" align="float:right" style="text-align: right" v-if="item.billState === '2'" plain>签署成功</van-button>
            <van-button type="primary" size="small" align="float:right" style="text-align: right" v-if="item.billState === '3' || item.billState === '4'" plain>签署失败</van-button>
            <van-button type="primary" size="small" align="float:right" style="text-align: right" v-if="item.billState === '7'" plain>拒绝签署</van-button>
            <van-button type="primary" size="small" align="float:right" style="text-align: right" v-if="item.billState === '8'" plain>签署作废</van-button>
            <van-button type="primary" size="small" align="float:right" style="text-align: right" v-if="item.billState === 'F'" plain>签署冻结</van-button>
          </div>
        </div>
        <div slot="desc" style="top:12px">
          <van-cell-group>
            <!--            <van-cell title="房屋id" :value="item.houseNo" />-->
            <template v-if="item.billState !== '0'">
              <van-cell title="签署人姓名" :value="item.payerName" />
              <van-cell title="操作时间" :value="item.signStartTime" />
              <van-cell title="签署人证件号" :value="item.payerCertNo" />
            </template>

            <van-cell title="业主姓名" :value="item.ownerName" />
            <van-cell title="房屋地址" :value="item.houseAddress" />
            <van-cell title="交存状态">
              {{item.depositSign|sigeStatusFilter}}
            </van-cell>
            <van-row type="flex" justify="end" >
              <van-col span="7" v-if="item.depositSign === 'Y'&&(item.billState==='0' || item.billState==='4' || item.billState==='3')" style="text-align: right;">
                <van-button type="primary" size="normal" class="btn" @click="signCommit(item)">签署约定书</van-button>
              </van-col>
<!--              <van-col span="7" v-if="item.depositSign === 'Y'&&item.billState!='8' && item.billState!='7' && item.billState!='F' && item.billState!='U'">-->
<!--                <van-button type="primary" size="normal" class="btn" @click="flowCancel(item.sysGuid)">签署撤回</van-button>-->
<!--              </van-col>-->
              <van-col span="7" v-if="item.depositSign === 'Y'&&(item.billState==='1')" style="text-align: right;">
                <van-button type="primary" size="normal" class="btn" @click="signContinue(item)">继续签署</van-button>
              </van-col>
              <van-col span="7" v-if="item.billState==='2'" style="text-align: right;">
                <van-button type="primary" size="normal" class="btn" @click="downloadFile(item.sysGuid)">约定书下载</van-button>
              </van-col>
<!--              <van-col span="7" v-if="item.depositSign === 'X'&&item.billState==='2'">-->
<!--                <van-button type="primary" size="normal" class="btn" @click="signCommit(item)">继续支付</van-button>-->
<!--              </van-col>-->
            </van-row>
          </van-cell-group>
        </div>
        <div class="footer" slot="footer">

        </div>
      </van-card>
    </div>
</template>

<script>
import Top from '@/views/components/Top'
import {
  getAgreeList,
  flowCancel,
  downloadPdf,
  eSignBegin
} from '@/api/maintainFund/maintainFund'

export default {
    name: "DepAgreeList",
    filters:{
      sigeStatusFilter(status){
        const statusMap = {
          'X': '未交存',
          'Y': '已足额交存',
          'N': '未足额交存'
        }
        return statusMap[status]
      }
    },
    data() {
        return {
            owner:{},
            regionName: '',
            regionSearchName:'',
            regionNo: '',
            onLineDeposit: '',
            watchImgUrl: require("@/assets/watch.png"),
            agreeList:[],
            depositApply:{
              eSignRespose:{}
            }
        }
    },
    mounted() {
      this.getAgreeList()
    },

    components: {
        BvTop: Top,
    },
    methods: {
      flowCancel(sysGuid){
        let param = {
          sysGuid:sysGuid
        }
        flowCancel(param).then(res => {
          if (res.data.retCode === '0000') {  // 自交或者代交
            this.$dialog.alert({
              message: '签署取消成功！'
            }).then(() => {
              this.getAgreeList();
            });
          }else {
            this.$dialog.alert({
              message: res.data.retMsg
            })
          }
        }).catch(() => {
        });
      },
      getAgreeList(){
        getAgreeList().then(res => {
          this.agreeList = res.data
          console.log(res.data)
        })
      },
      signContinue(depAgreeInfo){
        this.depositApply.eSignRespose.signUrl = depAgreeInfo.signUrl
        this.depositApply.eSignRespose.depAgreeId = depAgreeInfo.sysGuid
        sessionStorage.setItem('depAgreeId', depAgreeInfo.sysGuid);
        sessionStorage.setItem('signUrl', depAgreeInfo.signUrl);
        this.$router.push({path: '/onlineDeposit/signChild/waitSign',query: {label: '等待交存约定书签署',depositApply: this.depositApply}})
      },
      downloadPdf(id) {
        console.log(id)
        var data = {
          depAgreeId:id
        };
        downloadPdf(data).then(res => {
          let blob = new Blob([res.data]);
          let url = this.getObjectURL(blob);
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = url;
          // 获取文件名
          link.download = '交存约定书.pdf';
          document.body.appendChild(link);
          link.click();
          URL.revokeObjectURL(link.href);
        });
      },
      getObjectURL(file) {
        let url = null;
        if (window.createObjectURL !== undefined) {
          url = window.createObjectURL(file);
        } else if (window.webkitURL !== undefined) {
          url = window.webkitURL.createObjectURL(file);
        } else if (window.URL !== undefined) {
          url = window.URL.createObjectURL(file);
        }
        return url;
      },
      signCommit(item){
        let owner = {
          houseNo: item.houseGuid,
          fillOwnerName:item.ownerName,
          fillOwnerCertNo:item.ownerCertNo,
          isowner: 'N',
        };
        console.log(item.ownerCertNo)

        eSignBegin(owner).then(res => {
          if (res.data.retCode === '0000') {  // 自交或者代交
            // this.$router.push({path: '/onlineDeposit/signUserMessage',query: {label: '签署人信息',owner: res.data.eSignRespose}})
            this.$dialog.alert({
              message: res.data.retDesc
            }).then(() => {
              this.$router.push({path: '/onlineDeposit/signUserMessage',query: {label: '签署人信息',owner: res.data.eSignRespose}})
            });
          }else{
            this.$dialog.alert({message: res.data.retDesc});
          }
          // else if(res.data.retCode === '1001'){
          //   this.$router.push({path: '/onlineDeposit/signChild/waitSign',query: {label: '等待交存约定书签署',depositApply: res.data}})
          // }else if (res.data.retCode === '1002') {
          //   // 他人签署中
          //   this.$dialog.alert({message: res.data.retDesc});
          // }else if(res.data.retCode === '1000'){
          //   // sessionStorage.setItem('payChannels',res.data.payChannels);
          //   // sessionStorage.setItem('houseDepMobiles',res.data.houseDepMobiles);
          //   sessionStorage.setItem('payChannels',JSON.stringify({payChannels:res.data.payChannels}));
          //   sessionStorage.setItem('houseDepMobiles',JSON.stringify({houseDepMobiles:res.data.houseDepMobiles}));
          //   console.log(JSON.stringify({payChannels:res.data.payChannels}))
          //   this.$router.push({path: '/onlineDeposit/depositMessage',
          //     query: {
          //       label: '交存申请'
          //       // , payChannels: res.data.payChannels,
          //       // houseDepMobiles: res.data.houseDepMobiles
          //   }})
          // }
        })
      },
      downloadFile(sysGuid) {
        const link = document.createElement('a')
        link.href = this.$APP_ROOT + '/api/maintenance-fund/weixin/sigeAgreePdf/'+sysGuid
        link.download = this.fileName
        link.style.display = 'none'
        link.click()
        this.showPopup = false
      },
    }
}
</script>

<style lang='scss' scoped>

.titleContent{
  font-size: 15px;
  border-width: 1px;
  display: inline-block;
  font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑', sans-serif;
  font-weight: 700;
  font-style: normal;
  text-align: left;
}
</style>
